module.exports = __webpack_public_path__ + "img/verified-primary.e04a8fe6.svg";